import { createContext, useContext, type ReactNode } from 'react';
import { useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import { api, type Me, ApiError } from './api.ts';

/** 현재 로그인 사용자. 401 이면 null (로그인 화면으로). */
const Ctx = createContext<UseQueryResult<Me | null> | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const q = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try { return await api<Me>('/auth/me'); }
      catch (e) { if (e instanceof ApiError && e.status === 401) return null; throw e; }
    },
    retry: false,
    staleTime: 60_000,
  });
  return <Ctx.Provider value={q}>{children}</Ctx.Provider>;
}

export function useMe() {
  const q = useContext(Ctx);
  if (!q) throw new Error('AuthProvider 밖에서 useMe 를 호출했다');
  return q;
}

export function useRefreshMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['me'] });
}
